import { DestroyRef, inject, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, switchMap } from 'rxjs';
import { Flipper } from '@flipper';

@Service()
export class NavigationListener {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly featureService = inject(Flipper);

  initialize() {
    // Initialize the navigation listener
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        // Filter session-timeout navigations to prevent extending the session when redirecting to the timeout page
        filter(event => !event.urlAfterRedirects.startsWith('/session-timeout')),
        switchMap(() => this.featureService.evaluate$()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
